import {
  httpRequest,
  querystringBuilderByObject
} from '@common/util/api-common.util';

export default class TarefasApi {
  static obterListaTarefas (
    medicoId,
    dataInicio,
    dataFim,
    tipoFiltro,
    tipoFiltroValue,
    ordenacao
  ) {
    const query = querystringBuilderByObject({
      medicoId,
      dataInicio,
      dataFim,
      tipoFiltro,
      tipoFiltroValue,
      ordenacao
    });
    return httpRequest(`tarefa/laudo${query}`).then(json => json.data);
  }

  static atualizarStatusDoLaudo (laudoId, status, etapa) {
    return httpRequest(`tarefa/laudo`, 'PATCH', {
      laudoId,
      status,
      etapa
    }).then(json => json.data);
  }

  static obterLaudoParaLiberacaoEmLote(codigo, pesquisaPorNumeroExame, pesquisaporNumeroPedido) {
    return httpRequest(`tarefa/laudo-liberacao-lote?codigoPesquisa=${codigo}&pesquisaPorNumeroExame=${pesquisaPorNumeroExame}&pesquisaPorNumeroPedido=${pesquisaporNumeroPedido}`).then(json => json.data);
  }
}



// WEBPACK FOOTER //
// ./src/pages/tarefas/tarefas.api.js